import { Component, ViewChildren, Renderer2, QueryList, HostListener,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import  {SecurAuthService} from '../services/securauth.service';

@Component({
  selector: 'app-loginauth',
  templateUrl: './loginauth.component.html',
  styleUrls: ['./loginauth.component.css']
})
export class LoginauthComponent  {

  @ViewChildren('otpInput') otpInputs: QueryList<any>;
  otp: string[] = ['', '', '', '', '', ''];
  receivedData: any;

  constructor(private renderer: Renderer2,private secureAuthService:SecurAuthService,private router: Router) { }

  ngOnInit() {
    this.secureAuthService.data$.subscribe(data => {
      this.receivedData = data;
    });
  }

  ngAfterViewInit(): void {
    if (this.otpInputs && this.otpInputs.length > 0) {
      const firstInput = this.otpInputs.first;
      if (firstInput) {
        this.renderer.selectRootElement(firstInput.nativeElement).focus();
      }
    }
  }

  onOtpInputChange(index: number, event: any) {
    if (event.length === 1 && index < 5) {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        this.renderer.selectRootElement(nextInput.nativeElement).focus();
      }
    } else if (event.length === 0 && index > 0) {
      const prevInput = this.otpInputs.toArray()[index - 1];
      if (prevInput) {
        this.renderer.selectRootElement(prevInput.nativeElement).focus();
      }
    }
    const isOtpComplete = this.otp.every(digit => digit !== '');
    if (isOtpComplete) {
      this.submitOtp();
    }
  }
  
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    if (clipboardData) {
      const pastedText = clipboardData.getData('text');
      if (pastedText.length === 6) {
        this.fillOtpInputs(pastedText);
        this.submitOtp();
        event.preventDefault();
      }
    }
  }

  fillOtpInputs(otp: string): void {
    if (otp.length === 6) {
      for (let i = 0; i < otp.length; i++) {
        if (this.otpInputs && this.otpInputs.length > i) {
          this.otp[i] = otp[i];
        }
      }
    }
  }

  submitOtp() {
    const otpValue = this.otp.join('');
    if (!this.receivedData || !this.receivedData.username) {
      window.history.back();
      return ;
    }
    const data = {
      username:this.receivedData.username,
      password:this.receivedData.password,
      auth_code:otpValue
    };
    this.secureAuthService.web_admin_validate(data).subscribe((res: any) => {
      console.log('response',res);
      if(res.success){
        let user_json:any = JSON.stringify(res.user);
        user_json = JSON.parse(user_json);
        const password_version = user_json.password_version || '';

        const now = new Date();
        const expirationTime = new Date(now.getTime() + 1 * 60 * 30 * 1000);
        const expirationTime2:any = expirationTime.getTime();
        localStorage.setItem('token', res.user['token']);
        localStorage.setItem('username', res.user['username']);
        localStorage.setItem('role', res.user['role']);
        localStorage.setItem('user_id', res.user['id']);
        localStorage.setItem('isLoggedIn', "true");
        localStorage.setItem('expirationTime', expirationTime2);
        localStorage.setItem('password_version', res.user['password_version']);
          this.router.navigateByUrl('/dashboard/cricket');
      }else{
        alert(res.message);
      }
    });
  }

}
